import { render, staticRenderFns } from "./TableThoSuaChua.vue?vue&type=template&id=6cf8ac9e&scoped=true"
import script from "./TableThoSuaChua.vue?vue&type=script&lang=js"
export * from "./TableThoSuaChua.vue?vue&type=script&lang=js"
import style0 from "./TableThoSuaChua.vue?vue&type=style&index=0&id=6cf8ac9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf8ac9e",
  null
  
)

export default component.exports